/**
 * Shared focus recipe (ui-audit A5): one ring recipe for interactive
 * components. The global `:focus-visible` outline in index.css stays as the
 * fallback for non-component elements; components opt into this ring instead.
 */
export const FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-acento-tinte';
